import { makeAutoObservable } from "mobx";

export interface DownloadProgress {
  current: number;
  total: number;
  fileName: string;
  category: string;
}

export class DownloadProgressStore {
  isDownloading: boolean = false;
  progress: DownloadProgress | null = null;
  editionName: string = "";
  abortController: AbortController | null = null;

  // Overwrite confirmation state
  showOverwriteConfirm: boolean = false;
  overwriteFolderName: string = "";
  onOverwriteConfirm: (() => void) | null = null;
  onOverwriteCancel: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  startDownload(editionName: string, total: number): AbortController {
    this.abortController = new AbortController();
    this.isDownloading = true;
    this.editionName = editionName;
    this.progress = {
      current: 0,
      total,
      fileName: "",
      category: "",
    };
    return this.abortController;
  }

  updateProgress(current: number, total: number, fileName: string, category: string) {
    this.progress = {
      current,
      total,
      fileName,
      category,
    };
  }

  cancelDownload() {
    if (this.abortController) {
      this.abortController.abort();
    }
    this.finishDownload();
  }

  finishDownload() {
    this.isDownloading = false;
    this.progress = null;
    this.editionName = "";
    this.abortController = null;
  }

  askOverwriteConfirmation(folderName: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.overwriteFolderName = folderName;
      this.showOverwriteConfirm = true;
      this.onOverwriteConfirm = () => {
        this.showOverwriteConfirm = false;
        this.overwriteFolderName = "";
        this.onOverwriteConfirm = null;
        this.onOverwriteCancel = null;
        resolve(true);
      };
      this.onOverwriteCancel = () => {
        this.showOverwriteConfirm = false;
        this.overwriteFolderName = "";
        this.onOverwriteConfirm = null;
        this.onOverwriteCancel = null;
        resolve(false);
      };
    });
  }

  get progressPercentage(): number {
    if (!this.progress || this.progress.total === 0) return 0;
    return Math.round((this.progress.current / this.progress.total) * 100);
  }
}
